<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>


    <!--    청소차량 및 환경미화원 작업-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle + ' 작업'"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {

        value.summary = {
          안전보건점검_사업장명: [],
          안전보건점검_점검표: []
        }

        value.summary['안전보건점검_사업장명'].push({
          [this.form.stdInfo.field_name]: 1
        })

        value.summary['안전보건점검_점검표'].push({
          [this.form.inspectionTitle.trim()]: 1
        })

        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle: '청소차량 및 환경미화원',
      form: {
        inspectionTitle: '청소차량 및 환경미화원',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '사무실 콘센트, 소화기 및 냉난방 상태 등',
          is_checked: ''
        },
        {
          id: 2,
          label: '차고지 출구 운전 상태, 주의운전 여부 및 고임목 설치 여부 등',
          is_checked: ''
        },
        {
          id: 3,
          label: '샤워장 미끄럼 방지 및 청결유지 상태',
          is_checked: ''
        },
        {
          id: 4,
          label: '안전보건교육 실시',
          is_checked: ''
        },
        {
          id: 5,
          label: '건강검진(채용전 포함)에 관한 사항',
          is_checked: ''
        },
        {
          id: 6,
          label: '수거에 관한 사항',
          is_checked: '',
          title: '종량제봉투 수집 운반',
        },
        {
          id: 7,
          label: '상차 적재에 관한 사항',
          is_checked: '',
          title: '종량제봉투 수집 운반',
        },
        {
          id: 8,
          label: '청소차 이동에 관한 사항',
          is_checked: '',
          title: '종량제봉투 수집 운반',
        },
        {
          id: 9,
          label: '자원회수시설에 관한 사항',
          is_checked: '',
          title: '종량제봉투 수집 운반',
        },
        {
          id: 10,
          label: '배출장소 이동 및 수거에 관한 사항',
          is_checked: '',
          title: '음식물쓰레기 수집 운반',
        },
        {
          id: 11,
          label: '음식물쓰레기 등 상차 및 이적에 관한 사항',
          is_checked: '',
          title: '음식물쓰레기 수집 운반',
        },
        {
          id: 12,
          label: '수거차량 이동에 관한 사항',
          is_checked: '',
          title: '음식물쓰레기 수집 운반',
        },
        {
          id: 13,
          label: '배출장소 이동 및 수거에 관한 사항',
          is_checked: '',
          title: '재활용품 수집 운반',
        },
        {
          id: 14,
          label: '재활용품 등 상차 및 이적에 관한 사항',
          is_checked: '',
          title: '재활용품 수집 운반',
        },
        {
          id: 15,
          label: '수거차량 이동에 관한 사항',
          is_checked: '',
          title: '재활용품 수집 운반',
        },
      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
